var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m776.62 573.38-112.5-112.5c-14.625-14.625-38.25-14.625-52.875 0s-14.625 38.25 0 52.875l48.375 48.75h-434.62c-20.625 0-37.5 16.875-37.5 37.5s16.875 37.5 37.5 37.5h434.62l-48.375 48.375c-14.625 14.625-14.625 38.25 0 52.875 7.125 7.5 16.5 11.25 26.25 11.25s19.125-3.75 26.625-10.875l112.5-112.5c14.625-14.625 14.625-38.625 0-53.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m900 75h-450c-61.875 0-112.5 50.625-112.5 112.5v281.25c0 10.5 8.25 18.75 18.75 18.75h151.5c9 0 17.25-6.375 18.375-15.375 3-23.625 13.875-46.5 31.875-64.125 26.25-26.25 62.625-37.875 100.12-31.125 23.25 4.125 44.25 16.875 61.125 33.375l108 108c16.875 16.875 29.25 37.875 33.375 61.125 6.75 37.5-4.875 73.875-31.125 100.12l-110.25 110.25c-16.875 16.875-37.875 29.25-61.125 33.375-37.5 6.75-73.875-4.875-100.12-31.125-18.375-18-28.875-40.5-31.875-64.125-1.125-9-9.375-15.375-18.375-15.375h-151.5c-10.5 0-18.75 8.25-18.75 18.75v281.25c0 61.875 50.625 112.5 112.5 112.5h450c61.875 0 112.5-50.625 112.5-112.5v-825c0-61.875-50.625-112.5-112.5-112.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputWidget);
export default __webpack_public_path__ + "static/media/input-widget.ee8956415a756dfba1a46ea5cc92685b.svg";
export { ForwardRef as ReactComponent };